/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".es-app-container[_ngcontent-%COMP%]{padding-bottom:180px}\n/*# sourceMappingURL=home.component.css.map*/"];
export { styles as styles };
